/**
 * Constantes de rotas da aplicação
 */

export const ROUTES = {
  SPLASH: '/splash',
  LOGIN: '/login',
  HOME: '/home',
  CAMPAIGN: '/campaign',
  REWARD: '/reward',
  HOW_IT_WORKS: '/how-it-works',
  REDIRECT: '/redirect',
} as const;

/**
 * Helper para criar rota de campanha com ID
 */
export function getCampaignRoute(campaignId: string): string {
  return `${ROUTES.CAMPAIGN}/${campaignId}`;
}
